import axios from 'axios';

/**
 * Create feedback
 *
 * @param {Object} payload
 *
 * @return {Promise}
 */
export const Create = payload => axios.post('mobile/feedback', payload);